import { CSSProperties, useEffect } from "react";
import { Coldex } from "../../../../../../utils/types/Coldex";
import "../../../../../PopUps/popUps.scss";
import { PopUpTitle } from "../../../../../Titles/PopUpTitle";
import {
  execUpdateDb,
  execUpdateDbClean,
} from "../../../../../../store/slices/userxColdex";
import { useAppDispatch, useAppSelector } from "../../../../../../store/Hooks";
import { RootState } from "../../../../../../store/Store";
import { SpinnerCircular } from "spinners-react";

export type ColdexTableRowMenuConfirmProps = {
  close: Function;
  coldex: Coldex;
};

const styles = {
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    padding: "10px",
  } as CSSProperties,
};

export default function ColdexTableRowMenuConfirm({
  close,
  coldex,
}: ColdexTableRowMenuConfirmProps) {
  const dispatch = useAppDispatch();

  const { updateDb } = useAppSelector((state: RootState) => state.userxcoldex);

  useEffect(() => {
    dispatch(execUpdateDb());

    return () => {
      dispatch(execUpdateDbClean());
    };
  }, []);

  return (
    <div className={true ? "open-PopUp" : "close-PopUp"}>
      <div className="popUp-Content">
        <PopUpTitle setIsOpen={close} title={"Información"} />

        <div style={styles.row}>
          {updateDb?.event === "loading" && <SpinnerCircular size={24} />}

          <pre>
            {updateDb?.event === "loading"
              ? "La base de datos se esta actualizando. \n Cargando..."
              : updateDb?.event === "success"
              ? "Cargado Exitosamente!"
              : updateDb?.event === "error"
              ? "Algo salió mal."
              : "message"}
          </pre>
        </div>
      </div>
    </div>
  );
}
